import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button, Tab, Tabs, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import HttpService from "../../../../hooks/Https-services";
import moment from "moment";
import MDEditor from "@uiw/react-md-editor";
import EditIcon from "@mui/icons-material/Edit";
import useConfig from "../../../../hooks/useConfig";
import { Delete } from "@mui/icons-material";
import PageRoutes, { APIRoutes } from "../../../../utils/constants";
import ActionButton, {
  ActionButtonGroup,
} from "../../../../Common/Component/ActionButton";
import SummaryEditor from "../../../../Common/Component/SummaryEditor";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import UndoIcon from "@mui/icons-material/Undo";
import momentTimezone from "moment-timezone";
const userTimeZone = momentTimezone.tz.guess();
interface GameSummaryTableProps {
  listOfGameSummary: any[];
  pageData: {
    page: number;
    total_entries: number;
    limit: number;
  };
  value: number;
  GetGameSummary: () => void;
  page: number;
  rowsPerPage: number;
  handleChangePage: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => void;
  handleChangeRowsPerPage: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
}

const GameSummaryTable = ({
  listOfGameSummary,
  pageData,
  GetGameSummary,
  page,
  value,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
}: GameSummaryTableProps) => {
  const [openSummaryDialog, setOpenSummaryDialog] = useState(false);
  const [currentGame, setCurrentGame] = useState<any>({});
  const configData = useConfig();
  const [preGameSummary, setPreGameSummary] = useState("");
  const [postGameSummary, setPostGameSummary] = useState("");
  const [preGameSummaryShort, setPreGameSummaryShort] = useState("");
  const [postGameSummaryShort, setPostGameSummaryShort] = useState("");
  const [postGameTitle, setPostGameTitle] = useState("");
  const [preGameTitle, setPreGameTitle] = useState("");
  const [tabValue, setTabValue] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const renderColor = (status: number) => {
    let colors = "#e54f4f";
    switch (status) {
      case 1:
        colors = "#e54f4f";
        break;
      case 2:
        colors = "#ffa600";
        break;
      case 3:
        colors = "#329632";
        break;
      default:
        colors = "#e54f4f";
        break;
    }
    return (
      <Box
        sx={{
          borderRadius: "50%",
          height: "30px",
          width: "30px",
          backgroundColor: colors,
        }}
      ></Box>
    );
  };
  const handleStatusChange = async (id: string, status: boolean) => {
    try {
      await HttpService.post(
        `${APIRoutes.UpdateGameSummary.replace(":id", id)}`,
        {
          isActive: !status,
        }
      );
      GetGameSummary();
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
      console.error("Error updating game summary status:", error);
    }
  };

  const handleOpenSummaryDialog = (row: any) => {
    setCurrentGame(row);
    setOpenSummaryDialog(true);
  };

  const handleDelete = async (id: string) => {
    try {
      await HttpService.post(
        `${APIRoutes.DeleteGameSummary.replace(":id", id)}`,
        {}
      );
      GetGameSummary();
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
      console.error("Error deleting game summary:", error);
    }
  };

  const handleCloseSummaryDialog = () => {
    setOpenSummaryDialog(false);
    setPreGameSummary("");
    setPostGameSummary("");
    setCurrentGame({});
  };
  useEffect(() => {
    if (currentGame) {
      setPreGameSummary(currentGame?.PreGameSummary);
      setPostGameSummary(currentGame?.PostGameSummary);
      setPreGameSummaryShort(currentGame?.PreGameShortSummary);
      setPostGameSummaryShort(currentGame?.PostGameShortSummary);
    }
  }, [currentGame]);
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const generateSummary = async (type: "pre_match" | "post_match") => {
    setIsLoading(true);
    try {
      const response = await HttpService.post(
        `${APIRoutes.GenerateGameSummary.replace(
          ":gameId",
          currentGame?.GameIDTts
        )}`,
        {
          channel: currentGame?.ChannelID,
          type: type,
        }
      );

      if (response?.data?.data) {
        if (type === "pre_match") {
          setPreGameSummary(response.data.data.content);
        } else {
          setPostGameSummary(response.data.data.content);
          await generateSummaryShort("post_match", postGameSummary);
        }
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
      console.error(`Error generating ${type}-game summary:`, error);
    } finally {
      setIsLoading(false);
    }
  };
  const generateSummaryShort = async (
    type: "pre_match" | "post_match",
    content: string
  ) => {
    setIsLoading(true);
    try {
      const response = await HttpService.post(
        `${APIRoutes.GenerateGameSummaryShort}`,
        {
          content: content,
          type: type,
        }
      );

      if (response?.data?.data) {
        if (type === "pre_match") {
          setPreGameSummaryShort(response.data.data.brief);
          setPreGameTitle(response.data.data.title);
        } else {
          setPostGameSummaryShort(response.data.data.brief);
          setPostGameTitle(response.data.data.title);
        }
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
      console.error(`Error generating ${type}-game summary:`, error);
    } finally {
      setIsLoading(false);
    }
  };

  const saveSummaries = async () => {
    try {
      await HttpService.post(
        `${APIRoutes.UpdateGameSummary.replace(":id", currentGame?.ID)}`,
        {
          preGameSummary,
          postGameSummary,
          preGameSummaryStatus: preGameSummary?.length > 0 ? 3 : 2,
          postGameSummaryStatus: postGameSummary?.length > 0 ? 3 : 2,
          postGameShortSummary: postGameSummaryShort,
          title: postGameTitle,
        }
      );

      handleCloseSummaryDialog();
      GetGameSummary();
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
      console.error("Error saving game summaries:", error);
    }
  };

  return (
    <Box>
      <Box sx={{ width: "100%", mb: 2 }}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Game</TableCell>
                <TableCell>Game Date & Time</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Edit</TableCell>
                <TableCell>Pre</TableCell>
                <TableCell>Post</TableCell>
                <TableCell>
                  Move to {value === 0 ? "Trash" : "Available"}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {listOfGameSummary && listOfGameSummary.length > 0 ? (
                listOfGameSummary.map((row: any, index: number) => {
                  const gameTime = row?.GameDetails?.game_date_time;
                  const formatedTime = momentTimezone
                    .tz(
                      gameTime,
                      "YYYY-MM-DD hh:mm:ss.SSSSSS a Z",
                      "America/New_York"
                    )
                    .tz(userTimeZone)
                    .format("h:mm a z");
                  const currentTime = moment();

                  const determineGameStatus = () => {
                    // Parse the game time into a moment object
                    const gameTimeMoment = momentTimezone
                      .tz(
                        gameTime,
                        "YYYY-MM-DD hh:mm:ss.SSSSSS a Z",
                        "America/New_York"
                      )
                      .tz(userTimeZone);

                    // Add 4 hours to game time
                    const gameTimePlus4Hours = gameTimeMoment
                      .clone()
                      .add(2.5, "hours");

                    // Check if current time is after game time + 4 hours
                    // If true, the game has been played (VOD)
                    // If false, the game is still live
                    return currentTime.isAfter(gameTimePlus4Hours)
                      ? "VOD"
                      : "LIVE";
                  };
                  const gameStatus = determineGameStatus();
                  return (
                    <TableRow
                      key={row.ID}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        <Link
                          to={PageRoutes.Watch.replace(":gameId", row.GameID)}
                          target="_blank"
                        >
                          {row?.GameDetails?.away_team}{" "}
                          {row?.GameDetails?.away_team_mascot} AT{" "}
                          {row?.GameDetails?.home_team}{" "}
                          {row?.GameDetails?.home_team_mascot} ({row.GameID})
                        </Link>
                      </TableCell>
                      <TableCell>
                        {momentTimezone
                          .tz(
                            row?.GameDetails?.game_date_time,
                            "YYYY-MM-DD hh:mm:ss.SSSSSS a Z",
                            "America/New_York"
                          )
                          .tz(userTimeZone)
                          .format("DD MMM YYYY hh:mm A")}
                      </TableCell>
                      <TableCell>
                        <div>{gameStatus}</div>
                      </TableCell>
                      <TableCell>
                        <ActionButton
                          width="50px"
                          onClick={() => handleOpenSummaryDialog(row)}
                          className={configData.buttonCommonClass}
                        >
                          <EditIcon />
                        </ActionButton>
                      </TableCell>
                      <TableCell>
                        {renderColor(row?.PreGameSummaryStatus)}
                      </TableCell>
                      <TableCell>
                        {renderColor(
                          gameStatus === "LIVE"
                            ? 1
                            : !row?.PostGameSummary
                            ? 2
                            : row?.PostGameSummaryStatus
                        )}
                      </TableCell>
                      <TableCell>
                        <ActionButtonGroup>
                          {/* <ActionButton
                          width="200px"
                          onClick={() =>
                            handleStatusChange(row.ID, row.IsActive)
                          }
                          className={configData.buttonCommonClass}
                        >
                          {row.IsActive ? "Move to Pending" : "Make available"}
                        </ActionButton> */}

                          <ActionButton
                            width="50px"
                            onClick={() =>
                              handleStatusChange(row.ID, row.IsActive)
                            }
                            className={configData.buttonCommonClass}
                          >
                            {value === 1 ? <UndoIcon /> : <Delete />}
                          </ActionButton>
                        </ActionButtonGroup>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <Typography variant="body1">No data found</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            colSpan={3}
            count={pageData.total_entries}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      </Box>

      {/* Summary Dialog */}
      <Dialog
        open={openSummaryDialog}
        onClose={handleCloseSummaryDialog}
        fullWidth
        maxWidth="xl"
      >
        <DialogTitle sx={{ color: "black" }}>Game Summaries </DialogTitle>
        <DialogContent>
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs value={tabValue} onChange={handleTabChange}>
              <Tab label="Pre-Game Summary" />
              <Tab label="Post-Game Summary" />
            </Tabs>
          </Box>

          {/* Pre-Game Summary Tab */}
          <Box hidden={tabValue !== 0} sx={{ mt: 2, display: "flex" }}>
            <SummaryEditor
              summaryContent={preGameSummary}
              onSummaryChange={setPreGameSummary}
              onGenerateClick={() => generateSummary("pre_match")}
              isLoading={isLoading && tabValue === 0}
              generateButtonText="Generate with AI"
              type="pre_match"
              loadingText="Generating..."
            />
          </Box>

          {/* Post-Game Summary Tab */}
          <Box hidden={tabValue !== 1} sx={{ mt: 2 }}>
            <SummaryEditor
              summaryContent={postGameSummary}
              shortContent={postGameSummaryShort}
              onSummaryChange={setPostGameSummary}
              onShortContentChange={setPostGameSummaryShort}
              onGenerateClick={() => generateSummary("post_match")}
              isLoading={isLoading && tabValue === 1}
              type="post_match"
              generateButtonText="Generate with AI"
              loadingText="Generating..."
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseSummaryDialog}>Cancel</Button>
          <Button onClick={saveSummaries} variant="contained" color="primary">
            Publish
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default GameSummaryTable;
